import styled, { keyframes } from 'styled-components';

import { colors } from 'chime-ui/system';

export const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div.attrs({
  role: 'alert',
  'aria-live': 'assertive',
})`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50%;
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 auto;
  border-radius: 100%;
  border: 4px solid rgba(102, 102, 102, 0.5);
  border-left-color: ${colors.darkGreen};
  border-top-color: ${colors.darkGreen};
  animation: ${rotate360} 2s linear infinite;
`;

export default Spinner;
